import { array, string, Type, interface as type } from 'io-ts';

import { dot } from '~/src/base/Optic';
import { P , P3 } from '~/src/geometry/point';
import { Four } from '~/src/base/Array/Four';

import { Curve } from './Curve';
import { Ruler } from './Ruler';
import { Label } from './Label';
import { Meta } from './Meta';
import { Mod } from '~/src/base/Function';
import { V3 } from '~/src/geometry/vector';

export interface Piece {
	Axes: Four<P3>;
	Curves: Curve[];
	Rulers: Ruler[];
	Labels: Label[];
	Meta: Meta;
	Title: string;
}

export const Piece: Type<Piece> = type({
	Axes: Four(P3),
	Curves: array(Curve),
	Rulers: array(Ruler),
	Labels: array(Label),
	Meta: Meta,
	Title: string,
});

export const _Rulers: (f: Mod<Ruler[]>) => Mod<Piece> = dot('Rulers');
export const _Curves: (f: Mod<Curve[]>) => Mod<Piece> = dot('Curves');

/**
 * An empty Piece.
 *
 * Contains nothing, with default axes.
 */
export const empty: Piece = ({
	Axes: [
		[ 1, 0, 0 ],
		[ 0, 1, 0 ],
		[ 0, 0, 1 ],
		[ 0, 0, 0 ]
	],
	Curves: [],
	Rulers: [],
	Labels: [],
	Meta: { Entries: [] },
	Title: '',
});

export const points = (piece: Piece) : P<V3>[] =>
	piece.Curves
		.map((curve: Curve) => curve.Segments)
		.flat(2)
;
